var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-tab-item",
    { attrs: { active: _vm.active, title: "Resumen de Servicios" } },
    [
      _c("article", [
        _vm.detail.length > 0
          ? _c(
              "section",
              { staticClass: "container-fluid mb-4" },
              [
                _c("icon-view", {
                  attrs: {
                    gradient: "",
                    icon: "fa fa-file-invoice-dollar",
                    "icon-background": "#FF7058",
                    "icon-color": "#fff",
                    title: "Servicio(s) bajo contrato"
                  }
                }),
                _vm._l(_vm.detail, function(item) {
                  return _c("row", {
                    key: `${item.visitSummaryId}-${item.serviceId}`,
                    attrs: { item: item }
                  })
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm.detail.length === 0
        ? _c("section", { staticClass: "container-fluid mb-4" }, [
            _c("div", { staticClass: "empty-content text-center" }, [
              _c("label", [
                _vm._v(
                  " No cuenta con servicios adicionales para facturar en este periodo. "
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }